import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Building2, Clock, CreditCard, Mail, ArrowLeft } from 'lucide-react';

const SubscriptionPending = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-cyan-50 to-orange-50 p-4">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl mb-4 shadow-lg">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
            MyVenueMate
          </h1>
        </div>

        <Card className="shadow-xl border-0">
          <CardContent className="pt-8 pb-8 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full mb-6">
              <Clock className="w-10 h-10 text-yellow-600" />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 dark:text-foreground mb-4">
              Subscription Pending Approval
            </h2>
            
            <p className="text-gray-600 dark:text-muted-foreground mb-6 max-w-md mx-auto">
              Your subscription request is currently under review. You&apos;ll be notified once it&apos;s approved by our team.
            </p>

            <div className="space-y-4 mb-8">
              <Card className="bg-teal-50 dark:bg-teal-900/20 border-teal-200 dark:border-teal-800">
                <CardContent className="pt-4 pb-4">
                  <div className="flex items-start space-x-3">
                    <CreditCard className="w-5 h-5 text-teal-600 mt-0.5" />
                    <div className="text-left">
                      <h3 className="font-semibold text-gray-900 dark:text-foreground text-sm mb-1">Want Instant Access?</h3>
                      <p className="text-xs text-gray-700 dark:text-muted-foreground mb-2">
                        Make a payment to get your subscription activated immediately without waiting for approval.
                      </p>
                      <Button
                        onClick={() => navigate('/choose-plan')}
                        size="sm"
                        className="bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700"
                      >
                        Choose Plan & Pay Now
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800">
                <CardContent className="pt-4 pb-4">
                  <div className="flex items-start space-x-3">
                    <Mail className="w-5 h-5 text-orange-600 mt-0.5" />
                    <div className="text-left">
                      <h3 className="font-semibold text-gray-900 dark:text-foreground text-sm mb-1">Need Help?</h3>
                      <p className="text-xs text-gray-700 dark:text-muted-foreground">
                        Contact us at <a href="mailto:info@myvenuemate.in" className="text-teal-600 font-semibold underline">info@myvenuemate.in</a> for any queries regarding your subscription.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <Button
              variant="outline"
              onClick={() => navigate('/login')}
              className="w-full"
            >
              Back to Login
            </Button>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            Powered by <span className="font-semibold text-teal-600">MYONK</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPending;
